const config = {
  snackbarTimeout: 5000,
  crop: {
    quality: 90,
    rotation: 0,
    maxDimensions: { width: 1200, height: 1200 },
    minDimensions: { width: 1000, height: 1000 },
  },
};

export default config;
